import { NgFor } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_TYPE,
  FV_MODAL_FOOTER_POSITION,
  FV_MODAL_POSITION,
  FV_MODAL_SIZE,
  FvButtonComponent,
  FvModalComponent,
} from '@discocil/fv-components';
import { GlobalLogVisualizerService } from '../../services/global-log-visualizer/global-log-visualizer.service';

@Component({
  selector: 'app-log-visualizer',
  templateUrl: './log-visualizer.component.html',
  standalone: true,
  imports: [NgFor, FvModalComponent, FvButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogVisualizerComponent implements AfterViewInit {
  private readonly globalLogVisualizerService = inject(
    GlobalLogVisualizerService
  );
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  modalRef = viewChild<FvModalComponent>('modal');
  body = viewChild.required<ElementRef>('body');

  FV_MODAL_FOOTER_POSITION = FV_MODAL_FOOTER_POSITION;
  FV_MODAL_POSITION = FV_MODAL_POSITION;
  FV_MODAL_SIZE = FV_MODAL_SIZE;
  BUTTON_COLOR = BUTTON_COLOR;
  BUTTON_SIZE = BUTTON_SIZE;
  BUTTON_TYPE = BUTTON_TYPE;

  currentLogs = signal<
    { timestamp: string; message: string; customData: string }[] | null
  >(null);

  updateLogs(): void {
    this.currentLogs.set(this.globalLogVisualizerService.currentLogs());
    this.changeDetectorRef.markForCheck();
  }

  ngAfterViewInit(): void {
    this.updateLogs();
    setTimeout(() => {
      this.modalRef()?.open();
    }, 200);
  }

  close(): void {
    this.modalRef()?.close();
  }

  parseJsonString(data: string): string {
    if (data) {
      const obj = JSON.parse(data?.trim());
      let pretty = JSON.stringify(obj, null, 2);

      pretty = pretty.replace(/^[\s\n]+/, '');

      return pretty;
    }

    return '';
  }

  scrollToBottom(): void {
    const element = this.body()?.nativeElement;

    if (element) {
      element.scrollTop = element.scrollHeight;
      this.changeDetectorRef.markForCheck();
    }
  }
}
